import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ai-startup',
  templateUrl: './ai-startup.component.html',
  styleUrls: ['./ai-startup.component.scss']
})
export class AiStartupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
